import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { ToDoFilter } from "../../../../Constants/Constants";
import ToDoNavBar from "./ToDoNavBar";
import ToDoUserProfile from "./ToDoUserProfile";

const ToDoSidebar = () => {
  const [open, setOpen] = useState(false);
  return (
    <Col xxl="3" xl="4" className="box-col-30">
      <div className="email-sidebar md-sidebar">
        <Btn color="primary" className="email-aside-toggle md-sidebar-toggle" onClick={() => setOpen(!open)}>
          {ToDoFilter}
        </Btn>
        <div className={`email-left-aside md-sidebar-aside ${open ? "open" : ""}`}>
          <Card className="overflow-hidden">
            <CardBody>
              <div className="email-app-sidebar left-bookmark custom-scrollbar">
                <ToDoUserProfile />
                <ToDoNavBar />
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </Col>
  );
};

export default ToDoSidebar;
